import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ChooseProgramStep } from '../steps/ChooseProgramStep';
import { VoidedCheck } from '../steps/voided-check/VoidedCheck';

import { chooseProgramStyles as styles } from '../styles/ChooseProgramStyles';

import {
    setCurrentStep,
    setMaxStep,
    selectShowVoidedCheckScreen,
    selectShowChooseProgramScreen,
    selectProgressBarRef,
} from 'common/features/store/duck/ui/org-enrollment-v2';
import { scrollTo } from '../utils/ScrollTo';
import { logOrgEnrollmentV2 } from 'config/analytics';

// We may not end up needing this top level component in the future, but I'm
// leaving it here for now in case we need any high level continue or routing logic here.
export const ChooseProgram = () => {
    const dispatch = useDispatch<any>();
    const showChooseProgramScreen = useSelector(selectShowChooseProgramScreen);
    const showVoidedCheckScreen = useSelector(selectShowVoidedCheckScreen);
    const progressBarRef = useSelector(selectProgressBarRef);

    useEffect(() => {
        scrollTo(progressBarRef);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        dispatch(setMaxStep(4));
        dispatch(setCurrentStep(4));
        logOrgEnrollmentV2('org_enrollment:choose_program_viewed');
    }, [dispatch]);

    return (
        <div className={styles.container}>
            {showChooseProgramScreen && <ChooseProgramStep />}
            {showVoidedCheckScreen && <VoidedCheck />}
        </div>
    );
};
